export const strainPrompt = (strainName) => {
    return `You are a cannabis content writer tasked with creating a full-length, SEO-optimized article for a cannabis THCa flower strain. Your goal is to rank highly for THCa-related keywords, educate readers about THCa, and convert them into customers through engaging, trustworthy content.

I will provide only the strain name. You must conduct thorough research using reliable sources (Leafly, Weedmaps, verified scientific articles, breeder websites, etc.) and do not fabricate anything. Leave out any unconfirmed info.

Tone: Friendly, informative, and entertaining. Combine real cannabis science with smart commentary and a touch of humor. Write for curious, well-informed buyers who want the best of both THC and THCa experiences.

Your Output Must Include:

Meta Title:
Max 60 characters


Include the phrase “THCa Flower” and the strain name + brief hook + CTA (e.g., “Buy now,” “Available online”)



Meta Description:
Max 160 characters


Include “THCa Flower,” strain name, brief effect or flavor hook + CTA (e.g., “Shop Blackberry THCa flower now”)



Intriguing H2:
Avoid generic strain names. Use a clickable headline that teases Blackberry’s unique qualities as THCa flower



Body Structure:
Intro Paragraph: Explain why THCa flower is trending, and why this strain is a top pick


H2: What is ${strainName} (THCa Flower)?


Include product classification, effect profile, and THCa-specific info


H2: Benefits of THCa Flower


Brief overview of what THCa is, why people prefer it (non-psychoactive until heated, legal gray area, high potency when smoked, etc.)


H2: Effects of ${strainName}


H2: Flavors and Aromas


H2: Lineage and Genetics


H2: Medical Uses


H2: Similar THCa Flower Strains


H2: Final Thoughts



Word Count: 1,000–1,200 words

SEO Goals:
Target primary keyword: “THCa Flower”


Secondary keywords: “${strainName} THCa,” “Buy THCa flower online,” “${strainName} effects,” etc.


Use formatting and headers to boost scannability and SEO.



Conversion Reminder:
Mention that THCa flower is available for purchase or delivery


Include soft CTAs like “Shop Blackberry THCa Flower online today” or “Explore legal THCa flower options”

    `
}


export const productTypesPrompt = {

    flower: (data) =>
        `Consider yourself a cannabis expert with a 20 years of experience in writing accurate information about cannabis flower and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized product description for a cannabis flower ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Flower
4. THC Content:  ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product Overview  (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Aroma and Flavor (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Effects and Benefits (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. THC Content & Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${data?.productName}+ + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (flower in this case) + effects/flavor + CTA (e.g., "Order now," "Explore ${data?.categoryName} Deals")
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Research the flavor, effects, and parent genetics.
2. Use keywords like "premium cannabis flower," "THC content," and "${data?.StrainType} strain" not randomly and not all of them but based on the categories provided above and the strain of the product.
3. Tone: Cool, witty, stoner-friendly.
4. Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.\ `
    ,
    concentrates: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis concentrate and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a cannabis concentrate ${data?.productName}.
Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Concentrate
4. THC Content: ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product & Type (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Flavor & Aroma (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Potency, Effects & Experience (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Usage Notes (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} (Product Name) + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} (Product Name) + ${data?.BrandName} (Brand Name), product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Include the type of concentrate; in this case it is ${data?.categoryName}, the strain (in this case it is ${data?.StrainType}), and the parent genetics.
2. Use SEO terms like ${data?.StrainType} live resin” or “THC concentrate” not randomly and not all of them but based on the category of the product. It is strict to use keywords related to the category of the product.
3. Keep the tone high-level but relatable for dab users.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.
MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES
    .\
              `
    , edibles: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis edibles and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a cannabis edible ${data?.productName}.
Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Edibles
4. THC Content:  ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Overview & Dosing (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Flavor & Texture (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Onset, Effects & Best Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Cannabinoid Content & Warnings (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Mention flavor, dosage per piece, total THC, and number of pieces.
2. Include keywords like "THC gummies," "cannabis-infused chocolate," and "edibles for sleep," not randomly and not all of them but based on the categories provided above and the strain of the product. The keywords must include the actual categories and strains of the product
3. Keep the tone snack-friendly and stoner-aware.
4. Restricted words: Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.
MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.\
      ` ,
    vapes: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about vapes and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a vape product, ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Vape
4. THC Content: ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product & Format (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Strain, Flavor & Draw (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Potency & On-the-Go Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Compatibility or Tech Features (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))

1. Include format (disposable, 510 thread, pod, etc.) and oil type not randomly and not all of them but based on the category of the product. It is strict to use keywords related to the category of the product.
2. Use keywords: “${data?.StrainType} vape cart,” “THC vape pen,” “cannabis oil cartridge” not randomly and not all of them but based on the category of the product.
3. Keep the tone chill, casual tone with clarity but relatable for vape users.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES\.`,

    wellness: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis wellness products and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a wellness product, ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Wellness
4. THC Content: ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:

1. Product Overview & Use Case (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Cannabinoid Content & Application Method (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

3. Effects & Benefits (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

4. Recommended Use & Audience (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))

1. Mention use cases (sleep, focus, pain relief, stress, etc.) not randomly and not all of them but based on the category and strain of the product. It is strict to use use cases related to the category and strain of the product.
2. Keywords: “CBD tincture,” “THC patch,” “cannabis balm,” “CBN capsules.” not randomly and not all of them but based on the category and strain of the product.
3. Keep the tone wellness-friendly but casual tone.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.
  `,
    accessories: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis accessory products and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a accessory product, ${data?.productName}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Accessory
4. THC Content: No because the product is non-cannabis
5. Strain: No because the product is non-cannabis
6. Weight of the Product: Not applicable becuase the product is non cannabis

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:

1. Product Overview & Purpose (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Design & Features (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. How It Enhances the Session (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Who It’s For (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + CTA (e.g., "Order now," "Shop Now," etc.)

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))

1. Mention use cases not randomly but based on the category of the product. It is strict to use use cases related to the category of the product.
2. Keywords: “rolling tray,” “weed pipe,” “grinder,” “stash container” not randomly and not all of them but based on the category and strain of the product.
3. Keep the tone fun, clever tone — show personality.
4. Restricted words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES .
  `,
    prerolls: (data) => `Consider yourself a cannabis expert with 20 years of experience in writing accurate information about cannabis pre-rolls and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized description for a cannabis pre-roll product, ${data?.productName}.
Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${data?.productName}
2. Brand Name: ${data?.BrandName}
3. Category: ${data?.categoryName} and the main category is Pre Rolls
4. THC Content:  ${data?.concatThc}
5. Strain: ${data?.StrainType}
6. Weight of the Product: ${data.concatProductWeight}
First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Overview (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Strain Info & Flavor (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Effects & Session Type (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. Standout Features (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${data?.productName} + ${data?.BrandName} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${data?.productName} + ${data?.BrandName} (Brand Name) + product type (${data?.categoryName} in this case) + effects/flavor + CTA (e.g., "Order now," "Shop Now," etc.)
Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Mention weight per joint (e.g., 1g, 0.5g), pack size, and infusion type if used.
2. Include keywords: “infused pre-roll,” “1g joint,” “pre-roll pack,” “[strain name] pre-roll,” not randomly and not all of them but based on the categories provided above and the strain of the product. The keywords must include the actual categories and strains of the product
3. Keep the tone smoke-smart and stoner-approved.
4. Restricted words: Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.
MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES.
  `
}

export const buildBrandMetaPrompt = ({
    brandName,
    heading,
    shortDescription,
    bottomDescription,
}) => {
    const safe = (v) => String(v ?? "").trim();
    console.log(brandName, "brandName");
    console.log(heading, "heading");
    console.log(shortDescription, "shortDescription");
    console.log(bottomDescription, "bottomDescription");
    const safeBrandName = safe(brandName) || "Not provided";
    const safeHeading = safe(heading) || "Not provided";
    const safeShortDescription = safe(shortDescription) || "Not provided";
    const safeBottomDescription = safe(bottomDescription) || "Not provided";
    const promptTemplate = `You are a cannabis brand storyteller and SEO copywriter creating high-quality, conversion-focused content for a cannabis BRAND page on Hyperwolf.

I will provide only the BRAND NAME.

Your job is to research the brand using reliable sources such as:
- Official brand websites
- Licensed dispensary listings
- Leafly
- Weedmaps
- Headset market reports
- Press releases
- Reputable retailer or menu pages

Do not fabricate facts. Do not invent founding dates, regions, awards, product categories, or brand claims. If verified information is limited, stay factual and lean into what can be safely said about the brand's product range, style, positioning, and consumer appeal.

Write for well-informed cannabis shoppers in California.

Tone should be:
- Friendly
- Trustworthy
- Conversational
- Informed
- Non-generic
- Never slangy or exaggerated

Very Important Rules
- Avoid generic filler like "premium quality," "top-tier," "best in class," or "industry-leading" unless clearly supported by research.
- Do not keyword-stuff.
- Do not make medical claims.
- Do not use hypey language that sounds templated or AI-generated.
- Keep the writing natural, specific, and brand-aware.
- Mention Hyperwolf naturally where relevant for delivery/purchase intent.
- Prioritize clarity, authenticity, and SEO value.

Output exactly in this structure:

TITLE:
Write a clean page title/H1 for the brand collection page.

Requirements:
- 3 to 7 words preferred
- Include the brand name
- Natural for users, not stuffed
- Example style: Alien Labs Cannabis Products

DESCRIPTION:
Write a concise supporting description for the top of the page.

Requirements:
- Around 70 to 120 words
- Summarize what the brand is known for
- Mention key product categories only if verified
- Mention shopping from Hyperwolf naturally
- No fluff, no repeated phrases

META_TITLE:
Use this format as the default pattern:
Buy [BRAND NAME] from Hyperwolf | 60-Min Weed Delivery
Meta Title: (Max 60 characters) Should include ${brandName} (Brand Name) + Hyperwolf + a concise delivery hook.

Rules:
- Keep the structure very close to this format
- Include the exact brand name
- Include "Hyperwolf"
- Include "60-Min Weed Delivery" whenever it fits naturally within the character limit
- Keep it concise and click-worthy
- Target roughly 45 to 60 characters
- Do not add extra product keywords unless absolutely necessary
- Do not make it sound generic

Fallback rule:
If the brand name is too long, shorten carefully while preserving the core structure and intent.
Acceptable shorter variation:
Buy [BRAND NAME] at Hyperwolf | Weed Delivery

META_DESCRIPTION:
Use this format as the default pattern:
Shop [BRAND NAME] products online. Buy from Hyperwolf with 60-minute weed delivery or scheduled delivery in California.
Meta Description: (Max 160 characters) Should include ${brandName} (Brand Name) + Hyperwolf + 60-minute weed delivery + scheduled delivery in California.

Rules:
- Keep the structure very close to this format
- Include the exact brand name
- Include "Hyperwolf"
- Include "60-minute weed delivery"
- Include "scheduled delivery in California"
- Keep it natural and readable, not robotic
- Target roughly 140 to 160 characters
- Do not stuff product types unless it genuinely improves relevance
- Do not use vague promotional language

Fallback rule:
If the brand name is long, shorten naturally while keeping the meaning intact.
Example fallback:
Shop [BRAND NAME] online at Hyperwolf. Get 60-minute weed delivery or scheduled delivery in California.

SHORT_DESCRIPTION:
Write a short brand summary.

Requirements:
- Around 40 to 70 words
- Mention the brand's identity, product focus, and what makes it appealing
- Keep it useful and specific
- End naturally with purchase intent where appropriate
- Avoid sounding repetitive with the main description

BOTTOM_TEXT:
Write a detailed SEO bottom text section for the brand page.

Critical output rule:
Return BOTTOM_TEXT as VALID HTML ONLY, not Markdown.

Word count:
- Target 1200 to 1500 words

Allowed HTML tags:
- <h2>
- <h3>
- <p>
- <ul>
- <li>
- <strong>

Do not use:
- <h1>
- <h4>, <h5>, <h6>
- Markdown headings
- Markdown bullets
- tables
- code fences
- divs or spans
- empty tags

HTML structure rules:
- The first heading inside BOTTOM_TEXT must be an <h2>, never an <h1>
- Every major section must start with <h2>
- Use <h3> only for subsections nested under the relevant <h2>
- Every heading must be followed by at least one full <p> paragraph
- Do not place two headings back-to-back unless absolutely necessary
- Most body copy must be written in <p> tags, not headings
- Do not turn sentence fragments into headings
- Use lists only when they improve readability and only for short grouped points
- Each list must be introduced by a short <p> before the <ul>
- Keep paragraphs medium length, usually 2 to 5 sentences
- Keep the HTML clean, readable, and properly nested

Required section flow for BOTTOM_TEXT:
1. <h2>About [BRAND NAME]</h2>
2. <h2>What [BRAND NAME] Is Known For</h2>
3. <h2>Product Categories from [BRAND NAME]</h2>
4. <h2>Flavor, Genetics, or Extraction Style</h2> only if verified
5. <h2>Why Shoppers Choose [BRAND NAME]</h2>
6. <h2>How to Shop [BRAND NAME] Online at Hyperwolf</h2>
7. <h2>Final Thoughts</h2>

Additional writing rules for BOTTOM_TEXT:
- Explain what makes the brand interesting to actual shoppers
- Mention flower, vapes, concentrates, edibles, pre-rolls, or other categories only if verified
- If a category is not clearly supported by research, do not force it in
- If the brand has a distinctive cultivation style, extraction approach, genetics focus, collaborations, or regional identity, highlight that
- Include SEO phrases naturally, such as:
  - [BRAND NAME] cannabis
  - buy [BRAND NAME] online
  - [BRAND NAME] delivery
  - shop [BRAND NAME] at Hyperwolf
- Do not repeat the same keyword over and over
- Avoid writing a generic brand essay that could apply to any cannabis company
- Keep the writing brand-specific, useful, and natural

Example formatting pattern for BOTTOM_TEXT:
<h2>About [BRAND NAME]</h2>
<p>Paragraph text here.</p>
<p>Paragraph text here.</p>

<h2>What [BRAND NAME] Is Known For</h2>
<p>Paragraph text here.</p>

<h3>Verified Product Focus</h3>
<p>Paragraph text here.</p>

<h2>Product Categories from [BRAND NAME]</h2>
<p>Paragraph text here.</p>
<ul>
  <li>Verified category one</li>
  <li>Verified category two</li>
</ul>

ALT_TEXT:
Write one SEO-friendly alt text for the primary brand image.

Requirements:
- Keep it concise
- Ideally 6 to 12 words
- Usually under 90 characters
- Describe what is actually visible in the image first
- Include the brand name only when useful
- If relevant, mention the product type or packaging shown
- Keep it natural, not stuffed
- Do not start with "Image of" or "Picture of"
- Do not write promotional copy
- Do not over-explain

Good alt text style examples:
- Alien Labs cannabis flower jar packaging
- Alien Labs branded vape packaging on display
- Alien Labs pre-roll product packaging close-up

Bad alt text examples:
- Buy Alien Labs weed products online at Hyperwolf with fast delivery
- Best premium Alien Labs cannabis brand image for California shoppers
- Image of Alien Labs weed product packaging and cannabis brand design

Final quality check before answering:
- Make sure the meta title matches the Hyperwolf delivery format
- Make sure the meta description matches the Hyperwolf delivery format
- Make sure alt text is short, descriptive, and SEO-aware
- Remove generic filler
- Remove any unverifiable claims
- Keep the voice natural and brand-specific
- Make sure BOTTOM_TEXT is valid HTML
- Make sure the first heading in BOTTOM_TEXT starts with <h2>
- Make sure most of the content is in <p> tags, not headings
- After each paragraph tag, use a <br/> line.

Return only the following fields in this exact order:

TITLE:

DESCRIPTION:

META_TITLE:

META_DESCRIPTION:

SHORT_DESCRIPTION:

BOTTOM_TEXT:

ALT_TEXT:

Input variables to use for this brand:
- BRAND_NAME: ${safeBrandName}
- HEADING: ${safeHeading}
- SHORT_DESCRIPTION_INPUT: ${safeShortDescription}
- BOTTOM_DESCRIPTION_INPUT: ${safeBottomDescription}`;

    return promptTemplate.replaceAll("[BRAND NAME]", safeBrandName);
};

export const buildBannerAltPrompt = ({ brandName, heading, imageName }) => {
    const safe = (v) => String(v ?? "").trim();
    return `You are an accessibility expert. Generate one concise banner image alt text for a cannabis brand website.

Brand Name: ${safe(brandName)}
Brand Heading: ${safe(heading)}
Banner Image File Name: ${safe(imageName)}

Rules:
- Return only one plain-text sentence.
- Maximum 125 characters.
- Maximum 10 words.
- Be specific and descriptive.
- Do not include labels, markdown, quotes, or extra explanation.`;
};

export const buildProductMetaPrompt = ({
    productName,
    brandName,
    categoryName,
    thcValue,
    thcUnit,
    strainType,
    weightValue,
    weightUnit,
}) => {
    const safe = (v) => String(v ?? "").trim();
    return `Consider yourself a cannabis expert with a 20 years of experience in writing accurate information about cannabis flower and all related strains and cannabis stoners' community building as well as SEO. You know their language and all the information about the strains. Now generate a concise, SEO-optimized product description for a cannabis flower ${safe(productName)}.

Product Information (for your reference, you can use it to generate the descriptions or for research purposes):
1. Product Name: ${safe(productName)}
2. Brand Name: ${safe(brandName)}
3. Category: ${safe(categoryName)} and the main category is Flower
4. THC Content: ${safe(thcValue)}${safe(thcUnit)}
5. Strain: ${safe(strainType)}
6. Weight of the Product: ${safe(weightValue)}${safe(weightUnit)}

First give the meta title and descriptions based on the guidelines written below, then the product description that must follow this structure:
1. Product Overview  (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
2. Aroma and Flavor (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
3. Effects and Benefits (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)
4. THC Content & Use (ONLY THE HEADING SHOULD BE WRAPPED IN DOUBLE STARS (**) AND NO FORMATTING IN THE TEXT UNDERNEATH)

Guidelines for meta title and description: (MAKE SURE THEIR HEADINGS "Meta Title" and "Meta Description" SHOULD BE WRAPPED IN DOUBLE STARS (**))
Meta Title: (Max 60 characters) Should include the ${safe(productName)} + ${safe(brandName)} (Brand Name) + a short hook + a CTA (e.g., "Shop now," "Available for delivery," etc.)
Meta Description: (Max 160 characters) Should include ${safe(productName)} + ${safe(brandName)} (Brand Name) + product type (flower in this case) + effects/flavor + CTA (e.g., "Order now," "Explore Premium Deals")

Guidelines for product description: (MAKE SURE "Product Description" IS SEPERATED FROM "Meta Title" and "Meta Description" USING THREE HYPHENS (---))
1. Research the flavor, effects, and parent genetics.
2. Use keywords like "premium cannabis flower," "THC content," and "${safe(strainType)} strain" not randomly and not all of them but based on the categories provided above and the strain of the product.
3. Tone: Cool, witty, stoner-friendly.
4. Forbidden words: zest, zesty, delights, delight, delightful, companion, embark, journey, allure, gem, vibe, vibes, friend, buddy, chill, vibrant, elevate, embodies, embrace.

MUST FOLLOW: DO NOT ADD QUANTITY OR WEIGHT PER ITEM OF THE PRODUCT UNLESS SPECIFICALLY MENTIONED IN THE PRODUCT NAME. IN CASE ANY INFORMATION I HAVE NOT GIVEN AND REQUIRED TO WRITE THE DESCRIPTION, YOU ALWAYS HASVE RIGHT TO USE THE BRAND NAME AND PRODUCT NAME TO FIND OTHER INSTANCES OF THE PRODUCT ON INTERNET AND FETCH THE REQUIRED INFOMRTION BUT MAKE SURE THAT THE INFORMATION IS CONFIRMED FROM MULTIPLE SOURCES. `;
};

export const blogMetaPrompt = (blogName) => {
    const safe = (v) => String(v ?? "").trim();
    return `You are an SEO metadata writer tasked with creating a high-quality meta title and meta description for a blog article. Your goal is to generate click-worthy, search-friendly metadata based on the blog title while keeping it accurate, natural, and aligned with search intent.

I will provide only the blog title. You must analyze the title carefully, understand the likely keyword theme and search intent, and write metadata accordingly. Do not fabricate details that are not supported by the title. Keep the wording specific, relevant, and human-friendly.

Tone: Clear, professional, natural, and SEO-aware. Write for real users first, while making the metadata strong for search visibility and click-through rate.

Your Output Must Include:

Meta Title:
Max 60 characters preferred



Can go up to 65 characters only if necessary



Must reflect the blog topic clearly



Should include the primary keyword/theme naturally



Should be compelling but not clickbait





Meta Description:
Max 160 characters



Must accurately describe what the article is about



Should include the main keyword/theme naturally



Should encourage clicks with a soft CTA where relevant





SEO Goals:
Identify the likely primary keyword from the blog title



Match the likely search intent behind the title



Write metadata that is concise, relevant, and engaging



Avoid keyword stuffing, vague generic wording, or misleading claims





Output Format:
Meta Title: [write here]
Meta Description: [write here]

Input Blog Title: ${blogName}`;
};